export const api_link = 'https://mycitytrip.haribo.com/api';